export default __webpack_public_path__ + "static/media/dashboard_price_icon.221b8490.svg";